<template>
    <div class="tab-container">
        <ul class="tab tab-block">
            <li
                v-for="tab in tabs"
                :key="tab[idField]"
                :class="{ active: (tab[idField] === currentTabId) }"
                class="tab-item"
            >
                <a
                    href
                    @click.prevent="$emit('click', tab[idField])"
                >
                    <slot name="tab" :tab="tab">
                        {{ tab[labelField] }}
                    </slot>
                </a>
            </li>
        </ul>

        <div>
            <keep-alive>
                <slot></slot>
            </keep-alive>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            default () {
                return [] // { id: "", title: "" }
            }
        },
        currentTabId: {
            type: String,
            default: ""
        },
        idField: {
            type: String,
            default: "id"
        },
        labelField: {
            type: String,
            default: "title"
        }
    }
}
</script>
